/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pregnancy-prescription.reducer';

export const PregnancyPrescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pregnancyPrescriptionEntity = useAppSelector(state => state.pregnancyPrescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pregnancyPrescriptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.detail.title">PregnancyPrescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.id">Id</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.active">Active</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pregnancyPrescriptionEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.prescription">Prescription</Translate>
          </dt>
          <dd>{pregnancyPrescriptionEntity.prescription ? pregnancyPrescriptionEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.labPrescription">Lab Prescription</Translate>
          </dt>
          <dd>{pregnancyPrescriptionEntity.labPrescription ? pregnancyPrescriptionEntity.labPrescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.radiologyStudy">Radiology Study</Translate>
          </dt>
          <dd>{pregnancyPrescriptionEntity.radiologyStudy ? pregnancyPrescriptionEntity.radiologyStudy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pregnancyPrescription.trimester">Trimester</Translate>
          </dt>
          <dd>{pregnancyPrescriptionEntity.trimester ? pregnancyPrescriptionEntity.trimester.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pregnancy-prescription" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pregnancy-prescription/${pregnancyPrescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PregnancyPrescriptionDetail;
